import { type UsageSeriesList } from '../../../../types';
import { DEFAULT_USAGE_PRECISION } from '../../../constants/common';

export function getMaxYValue(series: UsageSeriesList['series'], precision: number = DEFAULT_USAGE_PRECISION): number {
  const ticks = 4;
  const maxValue = getMaxSeriesValue(series);

  if (maxValue < Math.pow(10, -precision)) {
    return 1;
  }

  const headroom = 1.1;
  const target = maxValue * headroom;
  const stepOptions = [1, 2, 2.5, 5, 10];
  const roughStep = target / ticks;
  const exponent = Math.floor(Math.log10(roughStep));
  const magnitude = Math.pow(10, exponent);

  for (const step of stepOptions) {
    const interval = step * magnitude;
    const candidateMax = interval * ticks;

    if (candidateMax >= target) {
      return candidateMax;
    }
  }

  // Fallback: bump to next order of magnitude
  return 10 * magnitude * ticks;
}

export function getMaxSeriesValue(series: UsageSeriesList['series']): number {
  return series.reduce((currentMax, entry) => {
    let max = currentMax;
    for (const [key, value] of Object.entries(entry)) {
      if (!isNaN(Number(key)) && !!value) {
        max = Math.max(max, value);
      }
    }
    return max;
  }, 0);
}
